<template>
  <div class="package-item" @click="onPeriodsClick">
    <ImageClip
      class="package-item_cover"
      :src="item.cover_img"
      :width="coverWidth"
      :height="coverHeight"
    ></ImageClip>
    <div class="package-item_body">
      <div class="package-item_title-market">
        <div class="package-item_title">
          {{ item.package_name }}
        </div>
      </div>
      <div class="package-item_count">{{ item.course_total }}门课程</div>
      <div class="package-item_footer">
        <span class="package-item_sales">{{ item.sales_num }}人已报名</span>
        <CurrencyNew
          :price="item.price"
          :priceUnderline="item.sale_money == item.price ? 0 : item.sale_money"
          :priceTwo="true"
        ></CurrencyNew>
      </div>
    </div>
    <div class="package-item_apply" v-if="item.packageCourseStatus == 1"></div>
  </div>
</template>
<script>
export default {
  name: 'PackageItem',
  props: {
    item: {
      type: Object,
    },
    coverWidth: {
      type: Number,
      default: 282,
    },
    coverHeight: {
      type: Number,
      default: 188,
    },
  },
  methods: {
    onPeriodsClick() {
      let query = {
        nav: this.$route.query.nav,
        title: this.$route.query.title,
        recommend: this.$route.query.recommend,
      };
      this.$router.push({
        name: 'PackageCourseDetail',
        params: {
          id: this.item.id,
        },
        query,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.package-item {
  width: 588px;
  height: 188px;
  background: #ffffff;
  border-radius: 6px;
  float: left;
  display: flex;
  margin: 0 24px 24px 0;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);

    .package-item_cover {
      ::v-deep {
        img {
          transform: scale(1.1);
        }
      }
    }
  }

  &:nth-child(2n) {
    margin-right: 0;
  }
}
.package-item_cover {
  margin-bottom: 17px;
  border-radius: 6px 0 0 6px !important;

  ::v-deep {
    img {
      transform: scale(1);
      transition: all 0.5s;
    }
  }
}
.package-item_body {
  width: 277px;
  margin: 16px 0 16px 20px;
}
.package-item_title {
  width: 260px;
  // height: 22px;
  font-size: 15px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: LEFT;
  color: #333333;
  line-height: 22px;
}
.package-item_market {
  font-size: 14px;
  color: #999999;
}
.package-item_count {
  margin-top: 8px;
  width: 55px;
  height: 22px;
  font-size: 13px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: LEFT;
  color: #999999;
  line-height: 22px;
}
.package-item_footer {
  position: absolute;
  left: 302px;
  bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 268px;
  box-sizing: border-box;
  ::v-deep {
    .price-wrap {
      margin-bottom: 3px;
      .price-underline {
        margin-right: 11px;
      }
    }
  }
}
.package-item_sales {
  height: 22px;
  font-size: 13px;
  color: #999999;
  line-height: 22px;
}
.package-item_apply {
  width: 76px;
  height: 76px;
  position: absolute;
  top: 0;
  right: 0;
  border-top-right-radius: 8px;
  background: url('~@/assets/images/package/apply@2x.png');
  background-size: 100% 100%;
}
</style>
